import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import PageHeader from "@/components/PageHeader";
import CustomerAdvanceOrders from "./service/CustomerAdvanceOrders";

export default function RequiredOrderPage() {
  return (
    <div data-testid="required-order-page">
      <PageHeader
        eyebrow="14 / Spares"
        title="Required Order"
        subtitle="Customer and advance part orders — track each part from ordered to arrived to handed over."
      />
      <div className="px-8 py-6 space-y-6">
        <Link
          to="/spare-parts/stock"
          data-testid="goto-stock-planning"
          className="inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-wider text-ink-muted hover:text-ink transition-colors"
        >
          Stock planning (P201 / P501 uploads, min-max) <ArrowRight size={12} />
        </Link>
        <CustomerAdvanceOrders />
      </div>
    </div>
  );
}
